/**
 * RefType → 路由映射（通知点击跳转的唯一出口）。
 *
 * 通知铃与消息中心的列表都按 ref_type/ref_id 跳转，映射只能有一份：两处各写一份必然漂移，
 * 表现为「同一条通知从铃铛点能跳到工单、从消息中心点却原地不动」。
 * 无映射的 ref_type 返回 null，调用方只标记已读、不跳转。
 */
export function refRoute(refType?: string, refID?: string): string | null {
  if (!refType) return null;
  switch (refType) {
    case 'ticket':
      return refID ? `/tickets?id=${refID}` : '/tickets';
    case 'call':
      return refID ? `/calls?id=${refID}` : '/calls';
    case 'chat':
      return '/chat';
    case 'workflow':
    case 'workflow_task':
      return '/workflow';
    // 知识库（自建的问答库与全文库）已整体下线：指向它们的历史通知类型不再有落点，
    // 落到 default 的 null，调用方只标记已读、不跳转（不指向已 404 的地址）。
    case 'voc':
      return '/voc';
    case 'incident':
      return '/ops-center?tab=cockpit';
    case 'outbound':
      return refID ? `/outbound?id=${refID}` : '/outbound';
    default:
      return null;
  }
}
